import React, {useCallback, useMemo} from 'react';

import {WBIcon} from '@wandb/ui';

import {WeaveExpression} from '../../panel/WeaveExpression';
import * as Table from './PanelTable/tableState';
import {useUpdateConfigKey} from './PanelTable/util';
import {ControlFilter} from './ControlFilter';
import {PanelContextProvider} from './PanelContext';
import * as Panel from './panel';

const inputType = {type: 'list' as const, objectType: 'any' as const};
interface PanelQueryConfig {
  tableState?: Table.TableState;
}
type PanelQueryProps = Panel.PanelProps<typeof inputType, PanelQueryConfig>;

export const PanelQuery: React.FC<PanelQueryProps> = props => {
  const {config, updateConfig} = props;
  // const [expanded, setExpanded] = useState(false);
  // const weave = useWeaveContext();
  // const updateVal = useCallback(
  //   (newVal: number) => updateConfig({...config, value: newVal}),
  //   [config, updateConfig]
  // );
  const tableState = useMemo(() => {
    return config?.tableState ?? Table.emptyTable();
  }, [config?.tableState]);

  // useEffect(() => {
  //   if (config == null) {
  //     console.log('SETTING INITIAL QUERY CONFIG');
  //     updateConfig({tableState});
  //   }
  // }, [config, updateConfig, tableState]);

  // const rows = useRowsNode(props.input, tableState, weave);
  // const inputPageNode = useMemo(
  //   () =>
  //     CG.opLimit({
  //       arr: CG.opOffset({arr: rows, offset: CG.constNumber(0)}),
  //       limit: CG.constNumber(10),
  //     }),
  //   [rows]
  // );
  const preFilterFrame = useMemo(
    () => Table.getRowFrame(props.input),
    [props.input]
  );
  const updateTableState = useUpdateConfigKey('tableState', updateConfig);

  const setFilterFunction: React.ComponentProps<
    typeof ControlFilter
  >['setFilterFunction'] = useCallback(
    newNode => {
      return updateTableState(Table.updatePreFilter(tableState, newNode));
    },
    [tableState, updateTableState]
  );

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        // flex: '1 1 auto',
        paddingLeft: '12px',
        paddingBottom: '5px',
      }}>
      <div style={{display: 'flex'}}>
        <div style={{marginRight: 8}}>
          <WBIcon name="filter" />
        </div>
        <div style={{flexGrow: 1, marginTop: 2}}>
          <PanelContextProvider newVars={preFilterFrame}>
            <WeaveExpression
              noBox
              expr={tableState.preFilterFunction}
              setExpression={setFilterFunction}
            />
          </PanelContextProvider>
        </div>
      </div>
    </div>
  );
};

export const Spec: Panel.PanelSpec = {
  hidden: true,
  id: 'Query',
  Component: PanelQuery,
  inputType,
};
